export default [
  {
    name: '厦门大学（思明校区）',
    pos: [24.43832, 118.09451],
    at: '福建省厦门市思明区',
    members: [
      {
        name: '邱宇航',
        major: '计算机系'
      }
    ]
  },
  {
    name: '厦门大学（翔安校区）',
    pos: [24.60730, 118.31184],
    at: '福建省厦门市翔安区',
    members: [
      {
        name: '黄晓辰',
        major: '临床医学'
      },
      {
        name: '吴毅龙',
        major: '生物学'
      }
    ]
  },
  {
    name: '安徽工业大学',
    pos: [31.6914500000, 118.5116700000],
    at: '安徽省马鞍山市',
    members: [
      {
        name: '刘美岚',
        major: '经济统计学'
      }
    ]
  },
  {
    name: '北京科技大学',
    pos: [39.9913500000, 116.3607200000],
    at: '北京市海淀区',
    members: [
      { "name": "郑宇涵", "major": "机械类" }
    ]
  },
  {
    name: '北京邮电大学',
    pos: [39.9615800000, 116.3577700000],
    at: '北京市海淀区',
    members: [{ "name": "张伟超", "major": "邮政工程" }]
  },
  {
    name: '中华女子学院',
    pos: [39.9946600000, 116.4353800000],
    at: '北京市朝阳区',
    members: [{ "name": "吴琳珊", "major": "审计学" }]
  },
  {
    name: '福建工程学院',
    pos: [26.0348100000, 119.1954500000],
    at: '福建省福州市闽侯县',
    members: [{ "name": "李子晔", "major": "会计学" },
    { "name": "周智贤", "major": "机械设计制造及其自动化" },
    { "name": "余欣", "major": "风景园林" },
    { "name": "郑泽伟", "major": "会计学" }]
  },
  {
    name: '福建警察学院',
    pos: [26.0270700000, 119.3160700000],
    at: '福建省福州市仓山区',
    members: [{ "name": "林诗涵", "major": "法学" }]
  },
  {
    name: '福建农林大学',
    pos: [26.0822600000, 119.2397500000],
    at: '福建省福州市仓山区',
    members: [{ "name": "宋诗琪", "major": "生物科学类（含生物科学，生物科技专业）" },
    { "name": "游丽娜", "major": "工程管理" },
    { "name": "陈炜豪", "major": "环境工程" },
    { "name": "吴漾", "major": "食品质量与安全" },
    { "name": "刘子珊", "major": "园艺" },
    { "name": "陈炫祺", "major": "机械类" }]
  },
  {
    name: '福建商学院',
    pos: [26.1175300000, 119.2916000000],
    at: '福建省福州市鼓楼区',
    members: [{ "name": "江韵风", "major": "财务管理" }]
  },
  {
    name: '福建师范大学',
    pos: [26.0361300000, 119.3091800000],
    at: '福建省福州市仓山区',
    members: [{ "name": "郭欣烨", "major": "法学" },
    { "name": "叶玉琳", "major": "金融类" }]
  },
  {
    name: '福建师范大学协和学院',
    pos: [26.0213900000, 119.2039300000],
    at: '福建省福州市闽侯县',
    members: [{ "name": "张奕恒", "major": "国际经济与贸易" }]
  },
  {
    name: '福建医科大学',
    pos: [26.0707200000, 119.1882200000],
    at: '福建省福州市闽侯县',
    members: [{ "name": "林象兴", "major": "临床医学" }]
  },
  {
    name: '福建中医药大学',
    pos: [26.0732700000, 119.1808800000],
    at: '福建省福州市闽侯县',
    members: [{ "name": "黄丽娟", "major": "中药学" }]
  },
  {
    name: '福州大学',
    pos: [26.0598100000, 119.1978100000],
    at: '福建省福州市闽侯县',
    members: [{ "name": "涂健舒", "major": "化学工程与工艺" },
    { "name": "何心怡", "major": "数字媒体技术" },
    { "name": "吴茂源", "major": "公共管理类" },
    { "name": "赖育圣", "major": "计算机类" },
    { "name": "朱达铭", "major": "土木工程" }]
  },
  {
    name: '厦门理工学院',
    pos: [24.6235800000, 118.0872800000],
    at: '福建省厦门市集美区',
    members: [{ "name": "赖东平", "major": "港航" }]
  },
  {
    name: '厦门医学院',
    pos: [24.6057800000, 118.0039500000],
    at: '福建省厦门市集美区',
    members: [{ "name": "何蕾", "major": "临床医学" }]
  },
  {
    name: '佛山科技大学',
    pos: [23.0205920000, 113.0998430000],
    at: '广东省佛山市南海区',
    members: [{ "name": "陈维亮", "major": "金融学" }]
  },
  {
    name: '南方医科大学',
    pos: [23.193292, 113.341254],
    at: '广东省广州市白云区',
    members: [{ "name": "达瓦拉姆", "major": "药学" }],
    baidu: true
  },
  {
    name: '广西师范学院',
    pos: [22.846922, 108.326571],
    at: '广西省南宁市西乡塘区',
    members: [{ "name": "朱少伟", "major": "通信工程" }],
    baidu: true
  },
  {
    name: '海南大学',
    pos: [20.06255, 110.33554],
    at: '海南省海口市美兰区',
    members: [{ "name": "郭廷桢", "major": "土木工程" }],
    baidu: true
  },
  {
    name: '	铁道警察学院',
    pos: [34.795504, 113.657859],
    at: '河南省郑州市金水区',
    members: [{ "name": "林政阳", "major": "侦查学" }],
    baidu: true
  },
  {
    name: '湘潭大学',
    pos: [27.887929, 112.870634],
    at: '湖南省湘潭市雨湖区',
    members: [{ "name": "谢水花", "major": "化学工程与工艺" }],
    baidu: true
  },
  {
    name: '中南大学',
    pos: [28.1772, 112.934197],
    at: '湖南省长沙市岳麓区',
    members: [{ "name": "冯恺熙", "major": "机械类" }],
    baidu: true
  },
  {
    name: '南京理工大学',
    pos: [32.031716, 118.863613],
    at: '江苏省南京市玄武区',
    members: [{ "name": "蒋杭燕", "major": "经济学类" }],
    baidu: true
  },
  {
    name: '	南京中医药大学翰林学院',
    pos: [32.385053, 119.901391],
    at: '江苏省泰州市海陵区',
    members: [{ "name": "詹雅雯", "major": "国际经济与贸易" }],
    baidu: true
  },
  {
    name: '中国药科大学',
    pos: [32.0795, 118.786343],
    at: '江苏省南京市鼓楼区',
    members: [{ "name": "黄泓", "major": "药学类" }],
    baidu: true
  },
  {
    name: '江西财经大学',
    pos: [28.745488, 115.861379],
    at: '江西省南昌市青山湖区',
    members: [{ "name": "陈霖", "major": "管理科学与工程类(工程管理、房地产开发与管理)" }],
    baidu: true
  },
  {
    name: '江西科技师范大学',
    pos: [28.743125, 115.844465],
    at: '江西省南昌市青山湖区',
    members: [{ "name": "许泽凯", "major": "光电信息科学与工程" },
    { "name": "黄浩淳", "major": "法学" },],
    baidu: true
  },
  {
    name: '南昌航空大学',
    pos: [28.655925, 115.834287],
    at: '江西省南昌市新建县',
    members: [{ "name": "黄舒泽", "major": "应用化学" }],
    baidu: true
  },
  {
    name: '山东大学',
    pos: [36.681366, 117.066638],
    at: '山东省济南市历城区',
    members: [{ "name": "邓璐", "major": "材料类" }],
    baidu: true
  },
  {
    name: '山东理工大学',
    pos: [36.816021, 118.007401],
    at: '山东省淄博市张店区',
    members: [{ "name": "吴鸿伟", "major": "农业机械化及其自动化" }],
    baidu: true
  },
  {
    name: '空军工程大学',
    pos: [34.275873, 109.041927],
    at: '陕西省西安市灞桥区',
    members: [{ "name": "钱昊", "major": "指挥信息系统工程（指挥信息系统运用与保障）" }],
    baidu: true
  },
  {
    name: '上海财经大学',
    pos: [31.312204, 121.507443],
    at: '上海市杨浦区',
    members: [{ "name": "杨艾梅", "major": "统计学" }],
    baidu: true
  },
  {
    name: '香港教育大学',
    pos: [22.473608, 114.207261],
    at: '香港特别行政区大埔区',
    members: [{ "name": "王懿", "major": "创意艺术与文化荣誉文学士课程" }],
    baidu: true
  },
  {
    name: '台州学院',
    pos: [28.659448, 121.396397],
    at: '浙江省台州市椒江区',
    members: [{ "name": "黄玮弘", "major": "建筑学" }],
    baidu: true
  },
  {
    name: '同济大学浙江学院',
    pos: [30.740149, 120.791973],
    at: '浙江省嘉兴市南湖区',
    members: [{ "name": "黄馨仪", "major": "环境工程" }],
    baidu: true
  },
  {
    name: '浙江大学宁波理工学院',
    pos: [29.821252, 121.580907],
    at: '浙江省宁波市鄞州区',
    members: [{ "name": "赖锦水", "major": "工业设计" }],
    baidu: true
  },
  {
    name: '漳州卫生职业学院',
    pos: [24.5270500000, 117.6335900000],
    at: '福建省漳州市芗城区',
    members: [{ "name": "阮燕婷", "major": "护理" }]
  },
  {
    name: '上海健康医学院',
    pos: [31.0951630000, 121.6118700000],
    at: '上海市浦东新区',
    members: [{ "name": "桑珠", "major": "精密医疗器械技术" }]
  }
]


// WEBPACK FOOTER //
// ./src/data.js